<template>
      <div class="footer">

    <div class="footer_in">


      <div id="footer_in_box" class="footer_in_box footer_contact">
        <b>
          <font>follow us From at social media</font>
          从社交媒体上关注我们
        </b>
        <div class="about_pic"><img class="about_pic"
            :src="require('@/assets/images/two-dimensional.jpg')"
            alt="" /></div>
        <p class="about_text">关注官方二维码、掌握更多最新实时消息<br />也可以通过以下方式关注我们</p>
        <p class="about_text">

          <a href=""><img
              src="http://www.baonengjet.com/wp-content/themes/generalbusiness_free/images/taobao.png" /></a>
          <a href=""><img src="http://www.baonengjet.com/wp-content/themes/generalbusiness_free/images/weibo.png" /></a>
          <a href=""><img
              src="http://www.baonengjet.com/wp-content/themes/generalbusiness_free/images/tengxunweibo.png" /></a>
          <a href=""><img src="http://www.baonengjet.com/wp-content/themes/generalbusiness_free/images/baidu.png" /></a>
        </p>
      </div>

      <div id="footer_in_box" class="footer_in_box footer_contact">
        <b>
          <font>About Us</font>
          关于宝能公务
        </b>


        <p class="contact_text_p"><a href="http://www.baonengjet.com/topics/公务机客舱服务//"> 我要包机</a></p>
        <p class="contact_text_p"><a href="http://www.baonengjet.com/topics/包机会员尊享//">会员专享</a></p>
        <p class="contact_text_p"><a href="http://www.baonengjet.com/topics/公务机购机代理服务//">成为机主</a></p>
        <p class="contact_text_p"><a href="http://www.baonengjet.com/topics/托管流程//">我要托管</a></p>
      </div>


      <div id="footer_in_box" class="footer_in_box footer_linkss">
        <b>
          <font>contact us</font>
          联系我们
        </b>
        <p class="contact_text_p">联系电话：0755-36869800；186-6622-8267 </p>
        <p class="contact_text_p">联系邮箱：bnj_mkt@baonengjet.com</p>
        <p class="contact_text_p"> 联系地址：广东省深圳市宝安区兴业路1100号金利通金融中心T2-16楼</p>
      </div>

      <div id="footer_bottom_link" class="footer_in">
        <ul id="menu-%e5%8f%8b%e6%83%85%e9%93%be%e6%8e%a5" class="footer_bottom_link">
          <li id="menu-item-276" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-276"><a
              href="#">友情链接</a></li>
          <li id="menu-item-73" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-73"><a
              href="http://www.baoneng.com/">宝能集团</a></li>
        </ul>

        <p class="f_bq"> 版权所有 &copy;2020 宝能公务航空 | <a rel="nofollow" target="_blank"
            href="http://www.miitbeian.gov.cn/">粤ICP备17155161号</a> | <a class="banquan" target="_blank"
            href="http://www.com.cn">wordpress主题</a> | </p>
      </div>

    </div>

  </div>
</template>

<script>
export default {
  name: 'BnjFooter',
  data () {
    return {
      msg: ''
    }
  }
}
</script>

<style scoped>
@import "../assets/styles/style.css";
</style>



// WEBPACK FOOTER //
// src/components/bnj-footer.vue